import { Header } from "../componentes/header";


export const ElLoader = ({ sesion }) => {
  
  return (
    <>
      {/* <Header /> */}
     
      <div className="loader">
  <div className="justify-content-center jimu-primary-loading"></div>
</div>
    </>
  );
};
